/* src/app/components/energy-wallet-details/energy-wallet-details.component.scss */
ion-content {
  --padding-bottom: 0;
  --background: var(--ion-color-light);
  --padding-top: calc(env(safe-area-inset-top) + 8px);
}
ion-toolbar {
  --background: transparent;
  --min-height: 48px;
  --padding-start: 0;
  --padding-end: 0;
}
ion-title {
  font-size: 20px;
  font-weight: 700;
}
ion-card {
  border-radius: 16px;
}
.wallet-card {
  margin: 10px 0 0;
}
.wallet-card ion-card-header {
  padding-bottom: 8px;
}
.wallet-card ion-card-content {
  padding-top: 0;
}
.summary-value {
  font-size: 36px;
  font-weight: 800;
  letter-spacing: 0;
}
.wallet-summary-card {
  margin-top: 6px;
}
.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 24px;
}
.safe-bottom {
  height: calc(48px + env(safe-area-inset-bottom));
}
/*# sourceMappingURL=energy-wallet-details.component.css.map */
